import React, { useEffect, useState } from 'react';
import styles from './FullName.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { NextButton } from '../../../Common/CtaButton/NextButton';
import { FormField } from '../../../Common/FormField';
import { checkFormValidity, validateForm } from './validate';
import { NameFormErrors, NameFormTouched, RenderFormFieldProps } from './types';

export const FullName = () => {
    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastNameKana, setLastNameKana] = useState('');
    const [firstNameKana, setFirstNameKana] = useState('');

    const [touched, setTouched] = useState<NameFormTouched>({
        lastName: false,
        firstName: false,
        lastNameKana: false,
        firstNameKana: false,
    });

    const [errors, setErrors] = useState<NameFormErrors>({
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
    });

    const [isFormValid, setIsFormValid] = useState(false);

    const handleValidation = () => {
        const formValues = {
            lastName,
            firstName,
            lastNameKana,
            firstNameKana,
        };

        const newErrors = validateForm(formValues, touched);
        setErrors(newErrors);
        setIsFormValid(checkFormValidity(formValues));
    };

    const handleBlur = (fieldName: string) => {
        setTouched(prev => ({
            ...prev,
            [fieldName]: true,
        }));
    };

    useEffect(() => {
        handleValidation();
    }, [lastName, firstName, lastNameKana, firstNameKana, touched]);

    const renderFormField = ({
        fieldName,
        fieldValue,
        setFieldValue,
        label,
        placeholder,
    }: RenderFormFieldProps) => (
        <div>
            <FormField
                label={label}
                placeholder={placeholder}
                value={fieldValue}
                onChange={setFieldValue}
                onBlur={() => handleBlur(fieldName)}
            />
            {errors[fieldName] && (
                <p className={styles.errorMessages}>{errors[fieldName]}</p>
            )}
        </div>
    );

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText="あなたの名前は？"
                        dataViewLabel="EF_氏名_pv"
                        dataClickLabel="EF_氏名_戻る"
                    />
                </div>

                <div className={styles.nameField}>
                    {renderFormField({
                        fieldName: 'lastName',
                        fieldValue: lastName,
                        setFieldValue: setLastName,
                        label: '姓',
                        placeholder: '山田',
                    })}
                    {renderFormField({
                        fieldName: 'firstName',
                        fieldValue: firstName,
                        setFieldValue: setFirstName,
                        label: '名',
                        placeholder: '太郎',
                    })}
                </div>

                <div className={styles.furiganaField}>
                    {renderFormField({
                        fieldName: 'lastNameKana',
                        fieldValue: lastNameKana,
                        setFieldValue: setLastNameKana,
                        label: 'セイ',
                        placeholder: 'ヤマダ',
                    })}
                    {renderFormField({
                        fieldName: 'firstNameKana',
                        fieldValue: firstNameKana,
                        setFieldValue: setFirstNameKana,
                        label: 'メイ',
                        placeholder: 'タロウ',
                    })}
                </div>

                <NextButton
                    formKey={[
                        'firstName',
                        'lastName',
                        'firstNameKana',
                        'lastNameKana',
                    ]}
                    formValue={[
                        firstName,
                        lastName,
                        firstNameKana,
                        lastNameKana,
                    ]}
                    displayFormKey={['name', 'nameKana']}
                    displayFormValue={[
                        `${lastName} ${firstName}`,
                        `${lastNameKana} ${firstNameKana}`,
                    ]}
                    isDisabled={!isFormValid}
                    dataClickLabel="EF_氏名_次へ"
                />
            </div>
        </div>
    );
};
